import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { useFeatures } from '@atc/features';
import { formatNumber } from '@atc/string-fns';

import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

/**
 * This hook compiles data from state to use for dealer SMS functionality
 * Alternatively, it can be provided a listing object to generate
 * the same text message if used on an SRP or other page with multiple
 * items of inventory
 *
 * @returns {String} text message copy requesting info about current listing
 * }
 */
export default function useDealerTextMessage(listing) {
    const [textBody, setTextBody] = useState('');

    const {
        brand: [, { brandName = 'Autotrader' }],
    } = useFeatures([
        'brand',
    ]);

    const listingFromStore = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);

    const {
        make,
        model,
        year,
        trim,
        pricingDetail: {
            incentive = '', salePrice = '', msrp = '',
        } = {},
        owner: { privateSeller, textNumber } = {},
    } = listing ?? listingFromStore;

    const title = [
        year,
        make?.name ?? make,
        model?.name ?? model,
        trim?.name ?? trim,
    ].filter(Boolean).join(' ');

    const price = incentive || salePrice || msrp;

    useEffect(() => {
        if (!privateSeller && textNumber) {
            setTextBody(`Hi, I'm interested in your ${title} listed on ${brandName}${price ? ' for ' + formatNumber({
                value: price,
                style: 'currency',
                currency: 'USD',
            }) : ''}`);
        } else {
            setTextBody('');
        }
    }, [privateSeller, textNumber, title, brandName, price]);

    return textBody;
}
